import { Link } from "react-router-dom";

export const AgreeTerms = ({ checked, onChange, testid = "agree-terms", text = "I agree to the" }) => (
  <label className="flex items-start gap-2 text-xs leading-relaxed" data-testid={`${testid}-label`}>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 shrink-0 accent-[var(--asv-accent)]" data-testid={testid} />
    <span className="asv-muted">{text} <Link to="/terms" target="_blank" className="font-semibold underline">Terms of Use</Link> and <Link to="/privacy" target="_blank" className="font-semibold underline">Privacy Policy</Link>.</span>
  </label>
);
